import { Portal, Sub, SubContent, SubTrigger } from '@radix-ui/react-context-menu';
import type React from 'react';
import { forwardRef } from 'react';
import Icon from '~/components2/Icon';
import { dropdownIconSize, itemClassNames, popupClassNames } from '../common';

interface SubMenuProps {
  label: string;
  className?: string;
  children?: React.ReactNode;
}

/**
 *  SubMenu for the ContextMenu allowing additional dropdown selections.
 *  ```tsx
 *  import SubMenu from '~/components2/ContextMenu/SubMenu'
 *
 *  <SubMenu label="Arrange">
 *    <Item onClick={() => bringToFront()}>Bring to Front</Item>
 *    <Item onClick={() => sendToBack()}>Send to Back</Item>
 *    <SubMenu label="Further Arrangement">
 *      <Item onClick={() => bringfoward()}>Bring Forward</Item>
 *      <Item onClick={() => sendBackward()}>Send Backward</Item>
 *    </SubMenu>
 *  </SubMenu>
 *  ```
 *  @param {label} props.label - label to display on the Submenu
 *  @param {children} props.children - (optional) Nested Items or additional SubMenu's
 *  @param {className} props.className - (optional) additional classNames to be added to the component styling.
 *  @returns
 */

const SubMenu = forwardRef<HTMLDivElement, SubMenuProps>(({ label, className, children, ...rest }, ref) => {
  return (
    <Sub>
      <SubTrigger className={`${itemClassNames} justify-between ${className}`}>
        {label}
        <Icon icon="chevronRight" size={dropdownIconSize} />
      </SubTrigger>
      <Portal>
        <SubContent className={popupClassNames} {...rest}>
          {children}
        </SubContent>
      </Portal>
    </Sub>
  );
});

SubMenu.displayName = 'SubMenu';
export default SubMenu;
